module.exports = "<div id=\"scaffolding-examples-page-id\">\r\n\r\n\t<app-scaffolding-examples></app-scaffolding-examples>\r\n</div>"